import queryString, {ParseOptions, StringifyOptions} from 'query-string';
import KU_QUERY from '@/constants/common/searchParamKeys';
import {hasKey} from './commonUtils';
import {isDevelopment} from '@/config/env';

// 如果当前所需要的searchQuery没有在配置中，此时需要清除并提示开发者
export function validateIsSearchParamsConfig(key: string): boolean {
    return hasKey(KU_QUERY, key);
}

function validateWithError(data: Record<string, unknown>, type: string) {
    Object.keys(data).forEach((key) => {
        if (!validateIsSearchParamsConfig(key)) {
            const log = isDevelopment ? console.error : console.warn;
            log(`[KuQuery]-${type} 当前字段 ${key} 没有在配置表中进行配置 请在@/constants/common/searchParamKeys进行配置`);
        }
    });
}

// 在这里处理key的限制
export const parse = (search: string, options?: ParseOptions) => {
    const result = queryString.parse(search, options);
    validateWithError(result, 'parse');
    return result;
};

// 在这里处理key的限制
export const stringify = (data: Record<string, unknown>, options?: ParseOptions) => {
    validateWithError(data, 'stringify');
    return queryString.stringify(data, options);
};

const getFullUrlWithSearch = (search?: string) => {
    return `${location.origin}${location.pathname}${search ? `?${search}` : ''}${location.hash}`;
};

/**
 * @description kuQuery增加/编辑searchQuery逻辑
 */
export const addSearchParamNoRefresh = (
    key: string,
    value: string | number | boolean,
    config?: StringifyOptions
) => {
    const urlObj = parse(location.search);
    const href = getFullUrlWithSearch(stringify({
        ...urlObj,
        [key]: value,
    }, config));
    history.replaceState(history.state, '', href);
};

/**
 * @description kuQuery删除searchQuery逻辑
 */
export const removeSearchParamNoRefresh = (key: string | string[]) => {
    const urlObj = parse(location.search);
    if (typeof key === 'string') {
        delete urlObj[key];
    } else {
        key.forEach((k) => {
            delete urlObj[k];
        });
    }
    const href = getFullUrlWithSearch(stringify(urlObj));
    history.replaceState(history.state, '', href);
};

/**
 * @description kuQuery获取searchQuery逻辑
 */
export function getUrlParams(): queryString.ParsedQuery<string> | null;
export function getUrlParams(key: ParseOptions): queryString.ParsedQuery<string>;
export function getUrlParams(key: string, config?: ParseOptions): string | string[] | null;
export function getUrlParams(
    key?: string | ParseOptions, config?: ParseOptions
): queryString.ParsedQuery<string> | string | string[] | null {
    if (!key && !config) {
        return parse(location.search);
    }
    // 没有key的情况
    if (typeof key === 'object') {
        return parse(location.search, key);
    }
    if (typeof key === 'string') {
        const pathParams = queryString.parse(window.location.search, config);
        return pathParams[key] || null;
    }
    return null;
}

const getSearchFromUrl = (url?: string) => {
    return url ? (new URL(url)).search : null;
};

/**
 * @description kuQuery 获取指定的url的参数
 */
export const getParamFromCustomUrl = (url: string, key?: string) => {
    const pathParams = parse(getSearchFromUrl(url) || '');
    return key ? pathParams[key] : pathParams;
};


/**
 * @description kuQuery 设置指定的url的参数
 */
export const addParamToCustomUrl = (
    url: string,
    key: string,
    value: string | number | boolean,
    config?: StringifyOptions
) => {
    const {origin, pathname = '', search} = new URL(url);
    const params = stringify({
        ...parse(search),
        [key]: value,
    }, config);
    const path = params.length ? pathname + '?' + params : pathname;
    return {
        href: origin + path,
        path,
    };
};
/**
 * @description kuQuery 删除指定的url的参数
 */
export const removeParamToCustomUrl = (
    url: string,
    key: string,
    config?: StringifyOptions
) => {
    const {origin, pathname = '', search} = new URL(url);
    const searchObject = parse(search);
    delete searchObject[key];
    const params = stringify({
        ...searchObject,
    }, config);
    const path = params.length ? pathname + '?' + params : pathname;
    return {
        href: origin + path,
        path,
    };
};

